/**
 * Maps a `mediaImage` / `mediaVideo` aspect ratio to a Tailwind class.
 * "auto" returns undefined so the asset keeps its intrinsic ratio.
 */
const MEDIA_ASPECT_CLASSES = {
  "1:1": "aspect-square",
  "3:2": "aspect-[3/2]",
  "4:3": "aspect-[4/3]",
  "16:9": "aspect-video",
} as const;

type MediaAspectRatio = keyof typeof MEDIA_ASPECT_CLASSES | "auto";

function getMediaAspectClass(
  aspectRatio?: MediaAspectRatio,
): string | undefined {
  if (!aspectRatio || aspectRatio === "auto") {
    return undefined;
  }

  return MEDIA_ASPECT_CLASSES[aspectRatio];
}

export { getMediaAspectClass };
